import queryString from 'query-string';

/**
 * Serializes API `next_page_params` object to a query string for GET /analytics/aggs
 */
export default function stringifyNextPageParams(obj) {
  if (!obj || typeof obj !== 'object') return '';
  const flat = {};
  Object.keys(obj).forEach((k) => {
    const v = obj[k];
    if (v === undefined || v === null) return;
    flat[k] = typeof v === 'object' && !Array.isArray(v) ? JSON.stringify(v) : v;
  });
  return queryString.stringify(flat);
}
